import Head from 'next/head'
import { SEODataType } from './types'
import { FC } from 'react'

interface SEOHeadProps {
  seoData: SEODataType | null
}

const SEOHead: FC<SEOHeadProps> = ({ seoData }) => {
  if (!seoData) return <></>

  const {
    metaTitle,
    metaDescription,
    canonicalURL,
    ogTitle,
    ogDescription,
    twitterTitle,
    twitterDescription,
    ogImage,
    twitterImage,
    metaKeywords,
  } = seoData

  return (
    <Head>
      {/* Meta tags for general SEO */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalURL} />

      {/* Open Graph (OG) meta tags for social sharing */}
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:image" content={ogImage?.url} />
      <meta
        property="og:image:width"
        content={ogImage?.width?.toString() ?? 300}
      />
      <meta
        property="og:image:height"
        content={ogImage?.height?.toString() ?? 200}
      />

      {/* Twitter card meta tags */}
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta name="twitter:image" content={twitterImage?.url} />
      <meta name="twitter:card" content="summary_large_image" />

      {/* Keywords */}
      <meta
        name="keywords"
        content={metaKeywords?.map((k) => k.string).join(', ')}
      />
    </Head>
  )
}

export default SEOHead
